import React, { useCallback, useEffect, useState } from "react";

import { debounce } from "lodash";
import { injectIntl } from "react-intl";
import UITypeSelect from "./UITypeSelect";

const SeasonRow = (props) => {
  const { itemIndex, result, initialValues, onSettingsChange, sport, intl } = props;
  const { formatMessage } = intl;

  const [matchLockTime, setMatchLockTime] = useState(0);

  const updateMatchLockTime = useCallback(
    debounce((value) => onSettingsChange("matchLockTime", Number(value)), 1500),
    [onSettingsChange],
  );

  const hasValueChanged = (key) => {
    return initialValues[key] !== result[key];
  };

  useEffect(() => {
    setMatchLockTime(result.matchLockTime);
  }, [result.matchLockTime]);

  return (
    <tr key={itemIndex}>
      <td>{result.name}</td>
      <td>{result.seasonId}</td>
      <td>
        <UITypeSelect
          onChange={(value) => {
            onSettingsChange("uiType", value);
          }}
          value={result.uiType}
          sport={sport}
          changed={hasValueChanged("uiType")}
          {...props}
        />
      </td>
      <td>
        <select
          type="text"
          onChange={(e) => {
            onSettingsChange("defaultRoster", e.target.value);
          }}
          value={result.defaultRoster}
          style={hasValueChanged("defaultRoster") ? { border: "2px solid green" } : {}}
        >
          <option key="SEASON" value="season">
            {formatMessage({
              id: "settings.default-roster.season",
              defaultMessage: "SEASON ROSTER",
            })}
          </option>
          <option key="FIXTURE" value="fixture">
            {formatMessage({
              id: "settings.default-roster.fixture",
              defaultMessage: "FIXTURE ROSTER",
            })}
          </option>
        </select>
      </td>
      <td>
        <input
          type="checkbox"
          checked={result.allowRosterSelect}
          style={hasValueChanged("allowRosterSelect") ? { outline: "3px solid green" } : {}}
          onChange={(e) => {
            onSettingsChange("allowRosterSelect", e.target.checked);
          }}
        />
      </td>
      <td>
        <input
          type="checkbox"
          checked={result.allowMatchOfficials}
          style={hasValueChanged("allowMatchOfficials") ? { outline: "3px solid green" } : {}}
          onChange={(e) => {
            onSettingsChange("allowMatchOfficials", e.target.checked);
          }}
        />
      </td>
      <td>
        <input
          type="checkbox"
          checked={result.allowMultipleCaptains}
          style={hasValueChanged("allowMultipleCaptains") ? { outline: "3px solid green" } : {}}
          onChange={(e) => {
            onSettingsChange("allowMultipleCaptains", e.target.checked);
          }}
        />
      </td>
      <td>
        <input
          type="number"
          value={matchLockTime}
          style={hasValueChanged("matchLockTime") ? { border: "2px solid green" } : {}}
          onChange={(e) => {
            setMatchLockTime(e.target.value);
            updateMatchLockTime(e.target.value);
          }}
        />
      </td>
    </tr>
  );
};

export default injectIntl(SeasonRow);
